import heroImage from "../assets/images/hero-banner.jpg";
import securityImg from "../assets/images/security.jpg";
import facilityImg from "../assets/images/facility.jpg";
import supportImg from "../assets/images/support.jpg";

export default function Page() {
  return (
    <div className="home">
      {/* HERO SECTION */}
      <section
        className="hero"
        style={{
          backgroundImage: `url(${heroImage})`,
        }}
      >
        <div className="hero-content">
          <h1>
            Reliable <span>Security</span> & <span>Facility Management</span>{" "}
            Services Across the UK
            {/* Security & Facilities Solutions  */}
          </h1>
          <p>
            COLIPS delivers reliable security and facility management services
            across the UK, protecting people, property, and operations with
            practical solutions.
          </p>
          <div className="hero-buttons">
            <a href="/contact" className="btn-primary">
              Get a Quote
            </a>
            <a href="/about" className="btn-secondary">
              Learn More
            </a>
          </div>
        </div>
      </section>

      {/* ABOUT INTRO */}
      <section className="section light">
        <div className="container">
          <h2>Welcome to COLIPS FM</h2>
          <p>
            COLIPS is a trusted UK-based provider of security services and
            facility management solutions for commercial, residential, retail,
            and industrial environments. Our experienced team combines industry
            knowledge, trained personnel, and modern systems to deliver
            dependable, cost-effective services that keep your premises safe,
            compliant, and running smoothly.
          </p>
        </div>
      </section>

      {/* SERVICES OVERVIEW */}
      <div className="services-grid">
        <div className="service-card">
          <img src={securityImg} alt="Security Services" />
          <h3>Security Services</h3>
          <p>
            Our security services are designed to protect your people and
            premises with a strong, visible presence and smart monitoring
            solutions. We deliver reliable coverage that helps prevent risks and
            ensures a safe environment at all times.
          </p>
        </div>

        <div className="service-card">
          <img src={facilityImg} alt="Facility Management" />
          <h3>Facility Management</h3>
          <p>
            We provide comprehensive facility management services to keep your
            buildings clean, functional, and well maintained. Our team ensures
            smooth day-to-day operations so you can focus on your core business.
          </p>
        </div>

        <div className="service-card">
          <img src={supportImg} alt="Support Services" />
          <h3>Support Services</h3>
          <p>
            Our support services add an extra layer of safety and efficiency to
            your site operations. From on-site assistance to operational
            support, we help create secure and well-managed environments.
          </p>
        </div>
      </div>

      {/* WHY CHOOSE US */}
      <section className="section light">
        <div className="container">
          <h2>Why Choose COLIPS FM?</h2>

          <div className="features-grid">
            <div className="feature">
              Our staff are fully trained, vetted, and experienced in delivering
              high-quality security and facility services. We maintain
              professional standards to ensure every site is managed with care
              and responsibility.
            </div>
            <div className="feature">
              We operate around the clock to provide continuous support and
              rapid response whenever it’s needed. Our clients can rely on us
              day and night for consistent and dependable service.
            </div>
            <div className="feature">
              We understand that every site is different, which is why we create
              solutions based on your specific requirements. Our flexible
              approach ensures effective services that fit your operations and
              budget.
            </div>
            <div className="feature">
              Serving clients across the UK, we deliver reliable services with
              local understanding and national reach. Our commitment to quality
              and compliance makes us a trusted long-term partner.
            </div>
          </div>
        </div>
      </section>

      {/* CALL TO ACTION */}
      {/* <section className="cta">
        <h2>Looking for Reliable Facility Management?</h2>
        <p>Contact COLIPS FM today to discuss your requirements.</p>
        <a href="/contact" className="btn-primary">
          Contact Us
        </a>
      </section> */}
    </div>
  );
}
